<cdx-slotted-modal (close)="close()" [size]="size" [mobileFullHeight]="true">
	<h2 modal-header i18n="@@directToBootInformation-mainHeading">
		<span>How does it work?</span>
	</h2>
	<div modal-content>
		<section class="instructions">

			<div class="safety-info">
				<h2>Direct to Boot pick up</h2>
			</div>

			<div class="instructions-info">
				<img
					alt="We’ll load your order into your boot"
					class="howItWorks"
					src="/assets/images/how-it-works/direct-to-boot.png"
				/>
				<div class="text-container">
					<h5 i18n="@@directToBootInformation-followInstructionsInSmsHeading">
						We’ll load your order into your boot
					</h5>
					<p i18n="@@directToBootInformation-followInstructionsInSmsHeadingContent">
						Park in the Direct to Boot bay, stay in your car, and we’ll place your order into your boot.
					</p>
				</div>
			</div>

			<div class="instructions-info">
				<img
					alt="I’ll load my own order"
					class="howItWorks"
					src="/assets/images/how-it-works/i-will-load-my-order.png"
				/>
				<div class="text-container">
					<h5 i18n="@@directToBootInformation-followInstructionsInSmsHeading">
						I’ll load my own order
					</h5>
					<p i18n="@@directToBootInformation-followInstructionsInSmsHeadingContent">
						Park in a designated bay, then head to the door with the Direct to Boot logo to collect your
						order.
					</p>
				</div>
			</div>

			<div class="safety-info">
				<h2>Self service eLocker collection</h2>
			</div>

			<div class="instructions-info">
				<img
					alt="Get a text notification"
					class="howItWorks"
					src="/assets/images/how-it-works/locker-get-text.png"
				/>
				<div class="text-container">
					<h5 i18n="@@directToBootInformation-followInstructionsInSmsHeading">
						Get a text notification
					</h5>
					<p i18n="@@directToBootInformation-followInstructionsInSmsHeadingContent">
						When your order is ready, we’ll send you a unique code by text. Enter this code into the eLocker keypad when you arrive.
					</p>
				</div>
			</div>

			<div class="instructions-info">
				<img
					alt="Collect your groceries"
					class="howItWorks"
					src="/assets/images/how-it-works/locker-collect-groceries.png"
				/>
				<div class="text-container">
					<h5 i18n="@@directToBootInformation-followInstructionsInSmsHeading">
						Collect your groceries
					</h5>
					<p i18n="@@directToBootInformation-followInstructionsInSmsHeadingContent">
						Grab your groceries from the locker—and that’s it!
						Note: eLockers aren’t available for Express Pick Up.
					</p>
				</div>
			</div>

			<cdx-alert
				[animate]="false"
				type="info"
				[withMargin]="false"
				[title]="noticeTitle"
				[description]="noticeDescription"
			></cdx-alert>

		</section>

	</div>
</cdx-slotted-modal>
